import { CategoryTreeNode } from './types'

type Profile = { name: string; language: string }

// Language-aware category name: current language, then first profile, then `#id`.
export function getCategoryName(
  category: { id: number; category_profiles?: Profile[] | null },
  language: string
): string {
  const profiles = category.category_profiles || []
  return (
    profiles.find(p => p.language?.toLowerCase() === language?.toLowerCase())
      ?.name ||
    profiles[0]?.name ||
    `#${category.id}`
  )
}

// Expand ids to themselves + all descendants. `tree` is the flat depth-first
// pre-ordered list from GET_CATEGORIES_TREE (descendants follow their parent
// with a greater depth_level). Unknown ids are kept as-is.
export function expandCategoryIdsWithDescendants(
  ids: number[],
  tree: Pick<CategoryTreeNode, 'id' | 'depth_level'>[]
): number[] {
  if (!tree.length) return ids
  const result = new Set<number>(ids)
  const selected = new Set(ids)
  for (let i = 0; i < tree.length; i++) {
    if (!selected.has(tree[i].id)) continue
    const depth = tree[i].depth_level
    for (let j = i + 1; j < tree.length && tree[j].depth_level > depth; j++) {
      result.add(tree[j].id)
    }
  }
  return Array.from(result)
}
